// source: design/src/pages/MESPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-mes.jpg',
  heroTitle: '制造执行系统 (MES)',
  heroTagline: '连接计划与执行，实现智能制造',
  intro: [
    'MES（Manufacturing Execution System，制造执行系统）是连接ERP计划层与车间执行层的关键信息系统，实现生产过程的实时可视化与精细化管控。',
    '作为智能制造的核心枢纽，MES系统实时采集设备数据、追踪生产进度、管理物料流转、控制产品质量，帮助企业实现生产透明化、质量可追溯、效率最大化。',
    '飞狼深耕制造行业多年，为汽车、电子、食品、医药等行业客户提供MES系统规划、实施与集成服务。',
  ],
  modules: [
    {
      icon: 'si/si-icons/route.svg',
      title: '工序追踪',
      desc: '实时追踪每道工序的加工状态、操作人员、设备参数，实现全程可追溯。',
    },
    {
      icon: 'si/si-icons/shield.svg',
      title: '质量管理',
      desc: 'SPC统计过程控制、首件检验、不合格品处理、质量追溯，降低不良率20%以上。',
    },
    {
      icon: 'si/si-icons/cpu.svg',
      title: '设备集成',
      desc: '通过OPC-UA协议与PLC、CNC等设备实时通讯，采集OEE关键数据。',
    },
    {
      icon: 'si/si-icons/package.svg',
      title: '物料管理',
      desc: '线上物料配送、Andon呼叫、物料防错，确保生产物料准时准确到位。',
    },
    {
      icon: 'si/si-icons/alert-triangle.svg',
      title: '异常管理',
      desc: '实时异常报警、escalation升级机制、异常处理闭环追踪。',
    },
    {
      icon: 'si/si-icons/file-text.svg',
      title: '电子批记录',
      desc: '电子化生产批次记录，满足FDA 21 CFR Part 11等法规要求。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/car.svg',
      title: '汽车制造',
      desc: '整车装配线实时节拍管控、零部件追溯、质量 gate 管理，生产效率提升15%以上。',
    },
    {
      icon: 'si/si-icons/circuit-board.svg',
      title: '电子装配',
      desc: 'SMT贴片过程控制、ESD管理、AOI集成，直通率提升至99%以上。',
    },
    {
      icon: 'si/si-icons/utensils-crossed.svg',
      title: '食品饮料',
      desc: '配方管理、批次追溯、HACCP合规，保障食品安全与质量一致性。',
    },
    {
      icon: 'si/si-icons/pill.svg',
      title: '医药生产',
      desc: '电子批记录、GMP合规、设备校验管理，满足严格监管要求。',
    },
  ],
  benefits: [
    {
      number: '15-25%',
      title: '生产效率提升',
      desc: '减少换线时间、优化生产节拍、降低在制品库存',
    },
    {
      number: '20%',
      title: '质量不良率降低',
      desc: 'SPC实时监控、防错机制、全程质量追溯',
    },
    {
      number: '10-15%',
      title: '设备OEE提升',
      desc: '实时OEE采集、预测性维护、快速故障响应',
    },
    {
      number: '95%+',
      title: '交付准时率',
      desc: '透明生产进度、智能排产、瓶颈预警',
    },
  ],
};
